<script>
    export let name = 'Lorem ipsum dolor sit amet';
    export let value = '$20.90';
</script>

<div class="uk-grid-small" uk-grid>
    <div class="uk-width-expand" uk-leader>{name}</div>
    <div class="uk-text-danger">{value}</div>
</div>